import { clsx } from 'clsx';

import { Icons, TimeTag } from '@monoimin/atoms';
import { IconNamesUnion } from '@monoimin/sb-types';

interface IconWithCaptionProps extends Omit<ComponentCommonProps, 'className'> {
  icon: IconNamesUnion;
  caption: string | number;
  classNames?: {
    container?: string;
    icon?: string;
    caption?: string;
  };
}

export const IconWithCaption = ({
  icon,
  caption,
  classNames,
}: IconWithCaptionProps) => {
  if (!caption) return null;
  const isDate = icon === 'calendar';
  return (
    <div className={clsx('flex items-center gap-2', classNames?.container)}>
      <Icons
        icon={icon}
        sizeClassName='w-4 h-4'
        className={classNames?.icon}
        isInteractive
      />
      {isDate ? (
        <TimeTag
          date={String(caption)}
          className={clsx('text-caption mt-0.5', classNames?.caption)}
        >
          {caption}
        </TimeTag>
      ) : (
        <span className={clsx('text-caption mt-0.5', classNames?.caption)}>
          {caption}
        </span>
      )}
    </div>
  );
};
